export const MetaSettings = {
  "/":{
    title:'Аренда кортов',
  },
  "/choosing-room":{
    title:'Аренда кортов',
  },
  "/time-and-court":{
    title:'Аренда кортов'
  },
  "/services":{
    title:'Сервис'
  },
  "/services/racket-calendar":{
    title:'Аренда ракеток'
  },
  "/services/racket-calendar/time-and-racket":{
    title:'Аренда ракеток'
  },
  "/services/products":{
    title:'Товары'
  },
  "/services/tennis-school":{
    title:'Школа тенниса'
  },
  "/services/personal-trainings":{
    title:'Персональные тренировки'
  },
  "/racket-calendar":{
    title:'Аренда ракеток'
  },
  "/time-and-racket":{
    title:'Аренда ракеток'
  },
  "/about":{
    title:'О клубе'
  },
  "/about/photo":{
    title: 'Галерея'
  },
  "/about/court-layout":{
    title: 'Схема кортов'
  },
  "/about/direction":{
    title: 'Схема проезда'
  },
  "/about/news":{
    title: 'Новости'
  },
  "/about/news/more":{
    title: 'Новость'
  },
  "/about/photo/ourClub":{
    title: 'Наш клуб'
  },
  "/about/photo/ourCourts":{
    title: 'Наши корты'
  },
  "/about/photo/ourSchool":{
    title: 'Школа тенниса'
  },
  "/about-app":{
    title:'О приложении'
  },
  "/padel":{
    title:'Padel'
  },
  "/padel/games":{
    title:'Padel - Игры'
  },
  "/padel/tournaments":{
    title:'Padel - Турниры'
  },
  "/rules":{
    title:'Правила Клуба'
  },
  "/privacy-policy":{
    title:'Политика конфиденциальности'
  },
  "/profile":{
    title:'Профиль'
  },
  "/profile/history":{
    title:'История покупок'
  },
  "/profile/cards":{
    title: 'Мои карты'
  },
  "/profile/add-card":{
    title: 'Добавление карты'
  },
  "/profile/settings":{
    title: 'Настройки'
  },
  "/profile/logout":{
    title: 'Выход'
  },
  "/profile/gruntReserve":{
    title: 'Перебронирование грунтов'
  },
  "/school":{
    title:'Школа тенниса'
  },
  "/school/modal":{
    title: 'Школа тенниса'
  },
  "/cart":{
    title:'Корзина'
  },
  "/payment":{
    title:'Оплата'
  },
  "/payment-confirm":{
    title:'Подтверждение оплаты'
  },
  "/payment-success":{
    title:'Оплата прошла успешно'
  },
  "/payment-error":{
    title:'Оплата не прошла'
  },
  "/contacts":{
    title:'Контакты'
  },
}
